module Environments {
    module.controller("AgentController", [
        "$scope",
        "AgentsService",
        "notifications",
        function ($scope, agentsService, notifications) {
            $scope.environment = _.find($scope.environments, function (environment: IEnvironment) {
                return environment.name === $scope.$stateParams.environmentName;
            });

            $scope.agentSaveRequest = false;

            $scope.saveAgent = function (agent) {
                $scope.agentSaveRequest = true;
                agentsService.save(agent).then(function (response) {
                    $scope.agentSaveRequest = false;
                    if (response) {
                        notifications.notify(response.data.message);

                        // Third argument forces a state transition.
                        // Without this, ui-router displays an old version of the state, without the new agent.
                        $scope.$state.go("environments.agentGroup", 
                            { 
                                environmentName: agent.agentGroup.environment.name, 
                                agentGroupName: agent.agentGroup.name 
                            }, { reload: true });
                    }
                });
            };
        }
    ]);
}